import {use} from 'react';

import {Context} from './context';

export const useTableContext = () => use(Context);
